var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4376 9.62484C14.9553 9.62484 15.375 9.20514 15.375 8.68742C15.375 8.1697 14.9553 7.75 14.4375 7.75C13.9198 7.75 13.5 8.16973 13.5 8.6875V9.62484H14.4376ZM11.8125 9.62484C12.3303 9.62484 12.75 9.20511 12.75 8.68734V6.0625C12.75 5.54473 12.3303 5.125 11.8125 5.125C11.2947 5.125 10.875 5.54473 10.875 6.0625V8.68734C10.875 9.2051 11.2947 9.62484 11.8125 9.62484Z",
    fill: "#2EB67D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56242 10.3752C6.0447 10.3752 5.625 10.7949 5.625 11.3126C5.625 11.8303 6.04474 12.25 6.56246 12.25C7.08023 12.25 7.5 11.8303 7.5 11.3125V10.3752H6.56242ZM9.1875 10.3752C8.66973 10.3752 8.25 10.7949 8.25 11.3127V13.9375C8.25 14.4553 8.66973 14.875 9.1875 14.875C9.70527 14.875 10.125 14.4553 10.125 13.9375V11.3127C10.125 10.7949 9.70527 10.3752 9.1875 10.3752Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 13.9376C10.875 14.4553 11.2947 14.875 11.8125 14.875C12.3302 14.875 12.7499 14.4553 12.7499 13.9375C12.7499 13.4198 12.3301 13 11.8124 13L10.875 13L10.875 13.9376ZM10.875 11.3125C10.875 11.8303 11.2948 12.25 11.8125 12.25L14.4374 12.25C14.9551 12.25 15.3749 11.8303 15.3749 11.3125C15.3749 10.7947 14.9551 10.375 14.4374 10.375L11.8125 10.375C11.2948 10.375 10.875 10.7947 10.875 11.3125Z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6.06242C10.125 5.5447 9.70526 5.125 9.18754 5.125C8.66982 5.125 8.25012 5.54474 8.25012 6.06246C8.25012 6.58023 8.66986 7 9.18762 7L10.125 7L10.125 6.06242ZM10.125 8.6875C10.125 8.16973 9.70523 7.75 9.18746 7.75L6.56262 7.75C6.04486 7.75 5.62512 8.16973 5.62512 8.6875C5.62512 9.20527 6.04486 9.625 6.56262 9.625L9.18746 9.625C9.70523 9.625 10.125 9.20527 10.125 8.6875Z",
    fill: "#36C5F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/slackIcon.1f5eb0121f205f0d93b7a3f5daaab27b.svg";
export { ForwardRef as ReactComponent };